import React from 'react';
import PropTypes from 'prop-types';
import { Callout } from '@bingads-webui-react/callout';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { FallbackContentBody, FallbackContentTitle } from './fallback-content';
import { getFallbackCalloutStyles } from './styles/fallback-callout';

const UnthemedFallbackCallout = ({
  children, title, placement, show, classes, handleClose,
  getOldUIPathOverride, siteMapId, target, closeButtonAriaLabel,
}) =>
  (
    <Callout
      title={<FallbackContentTitle title={title} />}
      content={<FallbackContentBody
        getOldUIPathOverride={getOldUIPathOverride}
        siteMapId={siteMapId}
        handleClose={handleClose}
      />}
      placement={placement}
      popoverId="fallback-callout"
      popoverClassName="bingads-webui-campaign-react-fallback-callout ignore-react-onclickoutside"
      closeButton
      show={show}
      classes={classes}
      onClose={handleClose}
      target={target}
      focusLockContent
      closeButtonAriaLabel={closeButtonAriaLabel}
    >
      {children}
    </Callout>
  );

UnthemedFallbackCallout.defaultProps = {
  children: undefined,
  placement: 'right',
  show: null,
  target: undefined,
  handleClose: () => { },
  classes: {},
  getOldUIPathOverride: null,
  siteMapId: null,
  closeButtonAriaLabel: undefined,
};

UnthemedFallbackCallout.propTypes = {
  children: PropTypes.element,
  target: PropTypes.node,
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  handleClose: PropTypes.func,
  show: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.oneOf([null]).isRequired,
  ]),
  classes: PropTypes.shape({}),
  getOldUIPathOverride: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  siteMapId: PropTypes.string,
  closeButtonAriaLabel: PropTypes.string,
};

export const FallbackCallout = withDefaultStyles(UnthemedFallbackCallout, getFallbackCalloutStyles);
